<template>
  <body class="top -top">
    <div id="page">
      <div id="content">
        <HeaderItem />
        <router-view></router-view>
      </div>
    </div>
  </body>
</template>

<script>
import HeaderItem from '@/components/parts/common/HeaderItem.vue';

export default {
  name: 'Top',
  components: {
    HeaderItem,
  }
}

</script>

<style>

</style>